/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import { client, withUnwrap } from '../.kubb/client'
import type {
  AuthLoginResendCodeOptions,
  AuthLoginResendCodeResponses,
} from '../models/AuthLoginResendCode'
import {
  authLoginResendCodeResponseSchema,
  authLoginResendCodeErrorSchema,
  authLoginResendCodeBodySchema,
} from '../schemas/authLoginResendCodeSchema'

/**
 * @summary Email a new login code for the pending token (the previous code stops working). At most once per 60 seconds and 5 times per login.
 * {@link /api/v4/auth/login/resendCode}
 */
export function authLoginResendCode<ThrowOnError extends boolean = true>(
  options: Options<AuthLoginResendCodeOptions, ThrowOnError>
): Unwrappable<RequestResult<AuthLoginResendCodeResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/api/v4/auth/login/resendCode',
      validator: {
        request: authLoginResendCodeBodySchema,
        response: authLoginResendCodeResponseSchema,
        error: authLoginResendCodeErrorSchema,
      },
      contentType: { request: 'application/json-patch+json' },
      ...config,
    }) as Promise<RequestResult<AuthLoginResendCodeResponses, ThrowOnError>>
  )
}
